import { Client } from 'urql';
import { propertyPageQuery } from './propertyPageQuery';

export const fetchPropertyPage = async ({
  client,
  slug,
  propertyId,
  toggleShowAVMData,
  toggleShowOriginNbnBrick,
  toggleMainImageDataMigration,
  togglePropertyReport,
  toggleBYBLegalDisclaimers,
  togglePcaChat,
  toggleMieleBanner,
  toggleGovernmentOverlaysUpdate,
  toggleVibeHunt,
}: {
  client: Client;
  slug: string;
  propertyId: string;
  toggleShowAVMData: boolean;
  toggleShowOriginNbnBrick: boolean;
  toggleMainImageDataMigration: boolean;
  togglePropertyReport: boolean;
  toggleBYBLegalDisclaimers: boolean;
  togglePcaChat: boolean;
  toggleMieleBanner: boolean;
  toggleGovernmentOverlaysUpdate: boolean;
  toggleVibeHunt: boolean;
}) => {
  const { data, error } = await client
    .query(propertyPageQuery, {
      slug,
      id: propertyId,
      toggleShowAVMData,
      toggleShowOriginNbnBrick,
      toggleMainImageDataMigration,
      togglePropertyReport,
      toggleBYBLegalDisclaimers,
      togglePcaChat,
      toggleMieleBanner,
      toggleGovernmentOverlaysUpdate,
      toggleVibeHunt,
    })
    .toPromise();
  return { data, error };
};
